import { Box, Typography } from '@mui/material';

import {
  CustomAutoComplete,
  CustomTextField,
  DrawerFormSection,
} from '../../../../common/components';
import {
  COST_AREA_OPTIONS,
  COST_BEHAVIOR_OPTIONS,
  COST_TRACEABILITY_OPTIONS,
} from '../../constants/supplierLedgerConstants';
import {
  FieldSelect,
  invoiceFieldSpan,
} from '../SupplierLedgerShared';

const SupplierInvoiceAccountingSection = ({
  form,
  movementConceptOptions,
  movementConceptsLoading,
  onChange,
}) => (
  <DrawerFormSection title="Detalle contable">
    <CustomAutoComplete
      label="Concepto"
      name="concept"
      value={form.concept}
      onChange={onChange}
      options={movementConceptOptions}
      loading={movementConceptsLoading}
      disabled={movementConceptsLoading || movementConceptOptions.length === 0}
      placeholder="Seleccionar concepto"
      helperText={
        movementConceptsLoading
          ? 'Cargando conceptos...'
          : movementConceptOptions.length === 0
            ? 'No hay conceptos activos cargados.'
            : movementConceptOptions.find((option) => option.value === form.concept)?.legacy
              ? 'Este concepto ya no está activo. Seleccioná uno del catálogo.'
              : undefined
      }
      getOptionLabel={(option) => option?.label || ''}
      renderOption={(props, option) => {
        const { key, ...optionProps } = props;
        return (
          <Box
            component="li"
            key={key}
            {...optionProps}
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-start',
              gap: 0.25,
              py: 0.75,
            }}
          >
            <Typography variant="body2" sx={{ fontWeight: 800, lineHeight: 1.2 }}>
              {option.label}{option.code ? ` · ${option.code}` : ''}
            </Typography>
            {option.description && (
              <Typography variant="caption" sx={{ color: 'text.secondary', lineHeight: 1.2 }}>
                {option.description}
              </Typography>
            )}
          </Box>
        );
      }}
      sx={invoiceFieldSpan(6, 2)}
    />
    <CustomTextField
      label="Cuenta contable"
      name="accounting_account_label"
      value={form.accounting_account_label}
      onChange={onChange}
      sx={invoiceFieldSpan(6, 2)}
    />
    <FieldSelect
      label="Fijo/Variable"
      name="cost_behavior"
      value={form.cost_behavior}
      onChange={onChange}
      options={COST_BEHAVIOR_OPTIONS}
      sx={invoiceFieldSpan(4)}
    />
    <FieldSelect
      label="Directo/Indirecto"
      name="cost_traceability"
      value={form.cost_traceability}
      onChange={onChange}
      options={COST_TRACEABILITY_OPTIONS}
      sx={invoiceFieldSpan(4)}
    />
    <FieldSelect
      label="Área"
      name="cost_area"
      value={form.cost_area}
      onChange={onChange}
      options={COST_AREA_OPTIONS}
      sx={invoiceFieldSpan(4)}
    />
  </DrawerFormSection>
);

export default SupplierInvoiceAccountingSection;
